document.addEventListener('DOMContentLoaded', function () {
    // A single pending check. Previously this was a setInterval whose handle was
    // stored in one shared variable: a second click before the first tick
    // overwrote the handle, orphaning the first interval so it polled /cart.js
    // once a second for the rest of the session. That was the source of the
    // 401/499 bursts on /cart.js in TrackJS.
    let pendingCheck = null;

    async function checkGiftCardAndRegularItems(variantId) {
        let cart;
        try {
            const response = await fetch('/cart.js', {
                headers: { 'Accept': 'application/json' }
            });
            // Don't parse or retry a 401/429 — just stand down.
            if (!response.ok) return;
            cart = await response.json();
        } catch (error) {
            // Aborted navigation, offline, blocked request. Not actionable,
            // and logging it here is what put it in TrackJS.
            return;
        }

        const items = (cart && cart.items) || [];
        const hasGiftCard = items.some(item => item.gift_card);
        const hasRegularItem = items.some(item => !item.gift_card);

        const sideCartDrawerBody = document.querySelector('.side-cart__drawer-body');
        if (sideCartDrawerBody) {
            sideCartDrawerBody.classList.toggle('hide-upsells', hasGiftCard && !hasRegularItem);
        }

        if (hasGiftCard && hasRegularItem) {
            const selector = document.querySelector('.side-cart__drawer-items');
            if (selector && !document.querySelector('.error-warning')) {
                const errorMessage = document.createElement('div');
                errorMessage.classList.add('error-warning');
                errorMessage.textContent = 'You cannot purchase a gift card along with other regular items.';
                selector.parentNode.insertBefore(errorMessage, selector.nextSibling);
            }

            const button = document.getElementById(`btn-${variantId}`);
            if (button) button.click();
        }
    }

    document.body.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-custom-add-to-cart]');
        if (!trigger) return;

        const variantId = trigger.getAttribute('data-add-item-id');

        // One deferred check per click. Rapid clicks collapse into a single
        // check instead of stacking pollers.
        clearTimeout(pendingCheck);
        pendingCheck = setTimeout(() => checkGiftCardAndRegularItems(variantId), 600);
    });
});
